(function () {

  function initCard(card) {
    const slider = card.querySelector('.grid-product-slider');
    const dotsUl = card.querySelector('.product-grid-gallery-dots');
    if (!slider || !dotsUl) return;

    if (card.dataset.dotsInit === '1') return;
    card.dataset.dotsInit = '1';

    const dots = Array.from(dotsUl.querySelectorAll('.product-grid-gallery-dot'));
    if (dots.length < 2) return;

    let ticking = false;

    function update() {
      const w = slider.clientWidth || 1;
      const idx = Math.max(0, Math.min(dots.length - 1, Math.round(slider.scrollLeft / w)));

      dots.forEach((dot, i) => dot.classList.toggle('is-actived', i === idx));
      ticking = false;
    }

    slider.addEventListener('scroll', () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });

    update();
  }

  function initAll() {
    document.querySelectorAll('.grid-product__image-wrap').forEach(initCard);
  }

  function scrollSliderToFirstFromSwatch(swatchEl) {
    const card = swatchEl.closest('.grid-item.grid-product');
    if (!card) return;

    const slider = card.querySelector('.grid-product__image-wrap .grid-product-slider');
    if (!slider) return;

    slider.scrollTo({ left: 0, behavior: 'smooth' });

    const dots = card.querySelectorAll('.product-grid-gallery-dot');
    if (dots.length) {
      dots.forEach((dot, i) => dot.classList.toggle('is-actived', i === 0));
    }
  }

  // once swatch click / hover scroll back to first image
  // click (for mobile)
  document.addEventListener('click', function (e) {
    const swatch = e.target.closest('.grid-product__colors .color-swatch');
    if (!swatch) return;
    scrollSliderToFirstFromSwatch(swatch);
  }, { passive: true });

  // hover (for desktop)
  document.addEventListener('mouseover', function (e) {
    const swatch = e.target.closest('.grid-product__colors .color-swatch');
    if (!swatch) return;
    scrollSliderToFirstFromSwatch(swatch);
  }, { passive: true });

  initAll();
  document.addEventListener('shopify:section:load', initAll);

  // Perf: batch to one initAll per frame, and only when element nodes were added
  let initQueued = false;
  const mo = new MutationObserver((mutations) => {
    if (initQueued) return;
    const hasAddedElements = mutations.some((m) =>
      Array.prototype.some.call(m.addedNodes, (n) => n.nodeType === 1)
    );
    if (!hasAddedElements) return;
    initQueued = true;
    requestAnimationFrame(() => {
      initQueued = false;
      initAll();
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
(() => {
  const SLIDER_SELECTOR = ".grid-product-slider";
  const LINK_SELECTOR = "a.grid-item__link";

  const DRAG_THRESHOLD_PX = 6;
  const OBSERVE_MS = 150;
  const SNAP_ON_RELEASE = true;

  // mobile enable flag
  let enabled = false;

  // drag state
  let isDown = false;
  let moved = false;
  let startX = 0;
  let startScrollLeft = 0;
  let activeSlider = null;
  let activeLink = null;

  let prevSnapType = "";
  let prevSnapStop = "";

  // observe state
  let observeTimer = null;
  let observeToken = 0;
  let pendingHref = null;

  function cancelObserve() {
    observeToken++;
    if (observeTimer) clearTimeout(observeTimer);
    observeTimer = null;
    pendingHref = null;
  }

  function startObserve() {
    if (!activeLink) return;
    const href = activeLink.getAttribute("href");
    if (!href) return;

    cancelObserve();
    const myToken = ++observeToken;
    pendingHref = href;

    observeTimer = setTimeout(() => {
      if (observeToken !== myToken) return;
      if (!pendingHref) return;
      window.location.href = pendingHref;
    }, OBSERVE_MS);
  }

  function getSliderFromEvent(e) {
    const t = e.target;
    if (!t || !t.closest) return null;
    return t.closest(SLIDER_SELECTOR);
  }

  function snapToNearest(slider) {
    const w = slider.clientWidth || 1;
    const idx = Math.round(slider.scrollLeft / w);
    slider.scrollLeft = idx * w;
  }

  // --- handlers (MUST be named for destroy) ---
  function onDragStart(e) {
    const slider = getSliderFromEvent(e);
    if (!slider) return;
    e.preventDefault();
    e.stopPropagation();
  }

  function onClick(e) {
    const slider = getSliderFromEvent(e);
    if (!slider) return;
    // prevent accidental navigation triggered by click
    e.preventDefault();
    e.stopPropagation();
  }

  function onMouseDown(e) {
    const slider = getSliderFromEvent(e);
    if (!slider) return;
    if (e.button !== 0) return;

    e.preventDefault();
    e.stopPropagation();

    activeSlider = slider;
    activeLink = slider.closest(LINK_SELECTOR);

    isDown = true;
    moved = false;
    startX = e.clientX;
    startScrollLeft = slider.scrollLeft;

    cancelObserve();

    prevSnapType = slider.style.scrollSnapType;
    prevSnapStop = slider.style.scrollSnapStop;

    slider.style.scrollSnapType = "none";
    slider.style.scrollSnapStop = "normal";

    document.documentElement.style.userSelect = "none";
    slider.classList.add("is-dragging");
  }

  function onMouseMove(e) {
    if (!isDown || !activeSlider) return;

    const dx = e.clientX - startX;
    if (Math.abs(dx) >= DRAG_THRESHOLD_PX) moved = true;

    activeSlider.scrollLeft = startScrollLeft - dx * 500;

    if (moved) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  function onMouseUp() {
    if (!isDown) return;

    isDown = false;

    if (activeSlider) activeSlider.classList.remove("is-dragging");
    document.documentElement.style.userSelect = "";

    const slider = activeSlider;
    const didMove = moved;

    // NOTE: keep activeLink until after observe decision
    const linkForObserve = activeLink;

    activeSlider = null;
    activeLink = null;

    if (!slider) return;

    requestAnimationFrame(() => {
      slider.style.scrollSnapType = prevSnapType || "";
      slider.style.scrollSnapStop = prevSnapStop || "";

      if (SNAP_ON_RELEASE && didMove) {
        requestAnimationFrame(() => snapToNearest(slider));
      }
    });

    if (!didMove) {
      // restore link for observe then start
      activeLink = linkForObserve;
      startObserve();
      activeLink = null;
    }
  }

  // --- enable/destroy ---
  function enableMobileDrag() {
    if (enabled) return;
    enabled = true;

    document.addEventListener("dragstart", onDragStart, true);
    document.addEventListener("click", onClick, true);
    document.addEventListener("mousedown", onMouseDown, true);
    document.addEventListener("mousemove", onMouseMove, true);
    document.addEventListener("mouseup", onMouseUp, true);
  }

  function destroyMobileDrag() {
    if (!enabled) return;
    enabled = false;

    document.removeEventListener("dragstart", onDragStart, true);
    document.removeEventListener("click", onClick, true);
    document.removeEventListener("mousedown", onMouseDown, true);
    document.removeEventListener("mousemove", onMouseMove, true);
    document.removeEventListener("mouseup", onMouseUp, true);

    // clean up runtime state (important if user resizes mid-drag)
    cancelObserve();

    if (activeSlider) {
      activeSlider.classList.remove("is-dragging");
      activeSlider.style.scrollSnapType = prevSnapType || "";
      activeSlider.style.scrollSnapStop = prevSnapStop || "";
    }
    document.documentElement.style.userSelect = "";

    isDown = false;
    moved = false;
    startX = 0;
    startScrollLeft = 0;
    activeSlider = null;
    activeLink = null;
  }

  // --- auto toggle by breakpoint ---
  const mq = window.matchMedia("(max-width: 768px)");

  function handleBreakpoint(e) {
    if (e.matches) enableMobileDrag();
    else destroyMobileDrag();
  }

  mq.addEventListener("change", handleBreakpoint);
  handleBreakpoint(mq);
})();